import { Controller } from '@hotwired/stimulus'
import Tribute from 'tributejs'

const HANDLEBARS_OPTIONS = [
  { key: 'working_period', description: 'Previous month + year from due date (or start date)' }
]

export default class extends Controller {
  static targets = ['input']

  connect() {
    this.initializeTribute()
  }

  disconnect() {
    if (this.tribute) {
      this.tribute.detach(this.inputTarget)
    }
  }

  initializeTribute() {
    this.tribute = new Tribute({
      trigger: '{{',
      values: HANDLEBARS_OPTIONS,
      lookup: 'key',
      fillAttr: 'key',
      selectTemplate: (item) => `{{${item.original.key}}}`,
      menuItemTemplate: (item) =>
        `<div class="d-flex justify-content-between gap-3">` +
          `<strong>{{${item.original.key}}}</strong>` +
          `<small class="tribute-description">${item.original.description}</small>` +
        `</div>`,
      noMatchTemplate: () => '<li class="p-2 text-muted">No matching variables</li>'
    })
    this.tribute.attach(this.inputTarget)
  }
}
